import {Component} from '@angular/core';

@Component({
  selector: 'app-confirm-price-icon',
  templateUrl: './confirm-price-icon.component.html'
})
export class ConfirmPriceIconComponent {
}
